<div class="modal-content">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-title-default">{{'TEST_DRIVE' | translate}}</h6>
      <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <i class="mdi mdi-close"></i>
      </button> -->
    </div>
    <div class="modal-body">
       <div class="row mt-5">
           <div class="col-12 text-center">
               <h1>{{ 'VOCE_TEM' | translate }} {{dias_restantes}} {{ 'DIAS_DE_TRIAL' | translate}}</h1>
           </div>
       </div>
       <div class="row">
           <div class="col-12 text-center">
               <h3>{{'PARA_ASSINAR_CONTATO' | translate}} </h3>
               <br />
               <h3>comercial@milvus.com.br</h3>
           </div>
       </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success badge-pill" (click)="close()">            
            <span [translate]="'FECHAR'"></span>
        </button>
    </div>
</div>